import React from 'react';

import { IRON } from '@wetransfer/transfer/constant/colors';

import { ErrorBigProps } from './types';

function ErrorBig({ className, color = IRON }: ErrorBigProps): JSX.Element {
  return (
    <svg
      width="170"
      height="170"
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M145.104 145.104C178.299 111.91 178.299 58.0905 145.104 24.8959C111.91 -8.29864 58.0905 -8.29864 24.8959 24.8959C-8.29864 58.0905 -8.29864 111.91 24.8959 145.104C58.0905 178.299 111.91 178.299 145.104 145.104ZM31.967 138.033C61.2563 167.322 108.744 167.322 138.033 138.033C167.322 108.744 167.322 61.2563 138.033 31.967C108.744 2.67767 61.2563 2.67767 31.967 31.967C2.67767 61.2563 2.67767 108.744 31.967 138.033Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.3591 49.8252C75.0879 44.6279 79.2523 40.3354 84.4567 40.3354C89.6632 40.3354 93.8328 44.6367 93.5822 49.8373C93.2747 56.2156 92.7661 64.8059 91.9967 72.3825C90.9125 83.0586 89.1734 93.1929 88.3716 97.5925C88.1283 98.9276 86.9627 99.8882 85.6056 99.8882H83.3196C81.9688 99.8882 80.8093 98.9431 80.5667 97.6143C79.8173 93.5096 78.2406 84.1813 77.0424 72.3825C76.2045 64.1314 75.6754 55.8859 75.3591 49.8252Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.4721 126.229C89.4962 126.229 93.569 122.127 93.569 117.067C93.569 112.007 89.4962 107.905 84.4721 107.905C79.4479 107.905 75.3751 112.007 75.3751 117.067C75.3751 122.127 79.4479 126.229 84.4721 126.229Z"
        fill={color}
      />
    </svg>
  );
}

export default ErrorBig;
